const DETERMINISTIC_PDF_SEED = "paperjsx-json-to-pdf-test";

let deterministicMode = false;

export function setDeterministicMode(enabled = true): void {
  deterministicMode = enabled;
}

export function isDeterministicModeEnabled(): boolean {
  return deterministicMode;
}

export function deterministicPdfFileIdSeed(): string {
  return DETERMINISTIC_PDF_SEED;
}
